export enum EUnitType {
  MS2 = 'MS2',
  G = 'G',
  MMS2 = 'MMS2',
  MMS = 'MMS',
  MS = 'MS',
  MKM = 'MKM',
  MM = 'MM',
  M = 'M',
  A = 'A',
  MA = 'MA',
  MKA = 'MKA',
  VOLT = 'VOLT',
  M_VOLT = 'M_VOLT',
  U_VOLT = 'U_VOLT',
  DEGREES = 'DEGREES',
  HZ = 'HZ',
  D_HZ = 'D_HZ',
  ROTATION_COUNT_IN_MINUTE = 'ROTATION_COUNT_IN_MINUTE',
  D_ROTATION_COUNT_IN_MINUTE = 'D_ROTATION_COUNT_IN_MINUTE',
  SECONDS_PER_ROTATION = 'SECONDS_PER_ROTATION',
  DEGREES_CELSIUS = 'DEGREES_CELSIUS',
  DEGREES_FAHRENHEIT = 'DEGREES_FAHRENHEIT',
  DEGREES_KELVIN = 'DEGREES_KELVIN'
}
